import { Link } from "react-router-dom";
import "../../assets/css/wes-careers.css";

const careersEmail = "careers@wes.net.au";

const openings = ["Customer Service Officer", "Showroom Retail Assistant", "Customer Sales", "Warehouse Storeperson"];

const requirements = [
  "Exceptional customer service skills",
  "Strong communication abilities",
  "Enthusiasm and self-motivation",
  "A professional and polished appearance",
  "A results-driven mindset",
];

const CheckIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#C8102E"
    strokeWidth="2.2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="wes-careers-style-19"
  >
    <path d="M5 12l5 5 9-10"></path>
  </svg>
);

export const JobEnquiries = () => {
  return (
    <main className="wes-careers-content">
      <section className="wes-careers-style-1">
        <div className="wes-careers-style-2">
          <nav aria-label="Breadcrumb" className="wes-careers-style-3">
            <Link to="/" className="wes-careers-style-4">
              Home
            </Link>
            <span aria-hidden="true">›</span>
            <span className="wes-careers-style-5">Careers</span>
          </nav>
          <div className="wes-careers-style-6">
            <span className="wes-careers-style-7">Join our team</span>
            <h1 className="wes-careers-style-8">Careers at WES Australasia</h1>
            <p className="wes-careers-style-9">
              WES Australasia, a trusted leader in the Australian electronics market for over 40 years, is dedicated to
              delivering exceptional customer service alongside high-quality electronic parts and accessories. With a
              catalogue of over 40,000 products, we’re looking for talented people to join our team.
            </p>
          </div>
        </div>
      </section>

      <section>
        <div className="wes-g2 wes-careers-style-10">
          <div className="wes-careers-style-11">
            <h2 className="wes-careers-style-12">Current openings</h2>
            <ul className="wes-careers-style-13">
              {openings.map((role) => (
                <li className="wes-careers-style-14" key={role}>
                  <span className="wes-careers-style-15">{role}</span>
                  <a
                    href={`mailto:${careersEmail}?subject=${encodeURIComponent(`Application: ${role}`)}`}
                    className="wes-careers-style-16"
                  >
                    Apply now →
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="wes-careers-style-11">
            <h2 className="wes-careers-style-12">What we’re looking for</h2>
            <ul className="wes-careers-style-17">
              {requirements.map((requirement) => (
                <li className="wes-careers-style-18" key={requirement}>
                  <CheckIcon />
                  {requirement}
                </li>
              ))}
              <li className="wes-careers-style-18">
                <CheckIcon />
                <span>
                  A passion for electronics, audio or audio-visual{" "}
                  <span className="wes-careers-style-4">— a plus, but not essential</span>
                </span>
              </li>
            </ul>
          </div>
        </div>
      </section>

      <section className="wes-careers-style-20">
        <div className="wes-careers-style-21">
          <div className="wes-careers-style-22">
            <h2 className="wes-careers-style-23">Ready to apply?</h2>
            <p className="wes-careers-style-24">
              Email your resume to <strong className="wes-careers-style-25">{careersEmail}</strong>
            </p>
          </div>
          <a href={`mailto:${careersEmail}`} className="wes-careers-style-26">
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <rect x="2" y="4" width="20" height="16" rx="2"></rect>
              <path d="M22 6l-10 7L2 6"></path>
            </svg>
            Email your resume
          </a>
        </div>
      </section>
    </main>
  );
};
